<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{ this.$route.name }}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-7">
            <a v-if="getRoleId != '33'" @click="openPage('/event/add')" class="btn-primary"><i
                class="fas fa-plus-square mr-5"></i>Add</a>
          </div>
          <div class="col-sm-5 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control"
                    placeholder="Search">
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small"
          :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
          <!--          <template slot="promo_code" slot-scope="data">-->
          <template v-slot:cell(promo_code)="data">
            <span>{{ (data.item.promo_code) ? data.item.promo_code.code : '-' }}</span>
          </template>
          <template v-slot:cell(promo_price)="data">
            <!--          <template slot="promo_price" slot-scope="data">-->
            <span>{{ (data.item.promo_code) ? data.item.promo_code.price : '-' }}</span>
          </template>
          <template v-slot:cell(start_date)="data">
            <!--          <template slot="start_date" slot-scope="data">-->
            <span>{{ data.item.start_date | moment("DD MMMM YYYY") }}</span>
          </template>
          <template v-slot:cell(end_date)="data">
            <!--          <template slot="end_date" slot-scope="data">-->
            <span>{{ data.item.end_date | moment("DD MMMM YYYY") }}</span>
          </template>
          <template v-slot:cell(branch)="data">
            <!--          <template slot="branch" slot-scope="data">-->
            <span>{{ (data.item.branch) ? data.item.branch.name : '-' }}</span>
          </template>
          <template v-slot:cell(status)="data">
            <!--          <template slot="status" slot-scope="data">-->
            <b-badge :variant="getBadge(data.item.status)">{{ data.item.status }}</b-badge>
          </template>
          <template v-slot:cell(thumbnail)="data">
            <!--          <template slot="thumbnail" slot-scope="data">-->
            <b-btn @click="showModal('event' + data.item.id)" size="sm" class="btn-table green"><i
                class="fas fa-eye mr-5"></i>View</b-btn>
            <b-modal class="modal-custom-image" hide-footer :ref="'event' + data.item.id" centered title="Event">
              <img class="w-100 img-fix" :src="parseImg(data.item.thumbnail)">
            </b-modal>
          </template>
          <!--          <template slot="actions" slot-scope="data">-->
          <template v-slot:cell(actions)="data">
            <b-button v-if="getRoleId != '33'" size="sm"
              @click="editData('/event/edit/' + data.item.slug + '?page=' + currentPage)"
              class="btn-table primary mr-1">
              <i class="far fa-edit"></i> Edit
            </b-button>
            <b-button v-if="getRoleId != '33'" size="sm" v-on:click="deleteData(data.item.id)" class="btn-table danger">
              <i class="fas fa-times"></i> Delete
            </b-button>
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage" :total-pages="totalPage"
          @page-changed="pageOneChanged" prev-text="Prev" next-text="Next" />
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from "@coreui/vue";
import axios from "axios";
import { Auth } from "@/api";
import Pagination from "@/views/component/pagination";

export default {
  name: "event",
  components: {
    "app-pagination": Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      fields: [
        {
          key: "name",
          label: "Name",
          sortable: true
        },
        {
          key: "start_date",
          label: "Start Date",
          sortable: true
        },
        {
          key: "end_date",
          label: "End Date",
          sortable: true
        },
        {
          key: "thumbnail",
          label: "Image",
          sortable: true
        },
        {
          key: "promo_code",
          label: "Promo Code",
          sortable: true
        },
        {
          key: "promo_price",
          label: "Promo Price",
          sortable: true
        },
        {
          key: "status",
          label: "Status",
          sortable: true
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false
        }
      ],
      items: [],
      sortType: "",
      sortBy: "",
      searchData: "",
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      getRoleId: Auth.Session.get().paradigm_role
    };
  },
  computed: {
    name() {
      return this.$route.name;
    }
  },
  methods: {
    pageOneChanged(pageNum) {
      let currentUrl = window.location.href
      let url = new URL(currentUrl)
      url.searchParams.set("page", pageNum)
      let newUrl = url.href
      window.history.pushState("Page", "Paradigm Fitness Indonesia", "?page=" + pageNum)
      this.currentPage = pageNum
      this.fetchData()
    },
    sortingChanged(event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy;
      if (event.sortDesc === false) {
        this.sortType = "asc";
        // console.log(this.sortType)
      } else {
        this.sortType = "desc";
        // console.log(this.sortType)
      }
      this.fetchData();
    },
    enterClicked(searchEvent) {
      this.fetchData();
    },
    getBadge(status) {
      return status === "Active"
        ? "success"
        : status === "Inactive"
          ? "danger"
          : status === "active"
            ? "success"
            : status === "inactive"
              ? "danger"
              : "primary";
    },
    getRowCount(items) {
      return items.length;
    },
    openPage(event) {
      this.$router.push(event);
    },
    editData(event) {
      this.$router.push(event);
    },
    showModal(id) {
      this.$refs[id].show();
    },
    parseImg(value) {
      return Auth.apiUrl + "compro/v1/img/events/" + value;
    },
    deleteData(event) {
      this.$swal({
        title: "Are you sure?",
        text: "You can't revert your action",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes Delete it!",
        cancelButtonText: "No, Keep it!",
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then(result => {
        if (result.value) {
          this.$swal(
            "Deleted",
            "You successfully deleted this file",
            "success"
          );
          axios.defaults.headers.common[
            "X-Access-Token"
          ] = Auth.Session.get().paradigm_token;
          axios
            .delete("compro/v1/events/".concat(event))
            .then(response => {
              // this.$router.go()
              this.fetchData();
            })
            .catch(error => {
              console.log("error", error);
            });
        } else {
          this.$swal("Cancelled", "Your file is still intact", "info");
        }
      });
    },
    fetchData() {
      axios
        .get(
          "compro/v1/events/all?page=" +
          this.currentPage +
          "&limit=" +
          this.paginationLimit +
          "&sorting=" +
          this.sortBy +
          "&sorting_type=" +
          this.sortType +
          "&keyword=" +
          this.searchData
        )
        .then(response => {
          this.items = response.data.data.rows;
          this.totalPage = response.data.meta.pageCount;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
    }
  },
  created() {
    let urlParams = new URLSearchParams(window.location.search)
    let pageParams = urlParams.get('page')
    this.currentPage = (pageParams != null) ? parseInt(pageParams) : 1
    this.fetchData()
  }
};
</script>

<style></style>
